import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/virtual.css'
import xm1 from '../assets/images/space.png'
import {Helmet}from"react-helmet";
import { PopupButton } from "react-calendly";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'
import ov1 from '../assets/images/ovm.png'
import ovv from '../assets/images/ovv.png'
import ov2 from '../assets/images/ov2.png'
import ovmm from '../assets/images/ovmm.png'
import ovmp from '../assets/images/ovmp.png'
import ovp from '../assets/images/ovp.png'
const Virtual = () => {

  useEffect(() => {
    AOS.init();
  }, []);
const advantages = [
  {
    image: ov1,
    title: "Prestigious Business Address",
    description:
      "Build credibility with a professional address in a prime Houston location.",
  },
  {
    image: ovv,
    title: "Live Receptionist",
    description:
      "Calls answered professionally in your company name.",
  },
  {
    image: ov2,
    title: "Flexible Workspace Access",
    description:
      "Access meeting rooms, coworking lounges, and day offices when needed.",
  },
];
const plans = [
  {
    title: "Business Address",
    description:
      "A professional business address with secure mail handling.",
    price: "$59",
    featured: false,
  },
  {
    title: "Live Answering",
    description:
      "Professional call answering in your company name.",
    price: "$69",
    featured: false,
  },
  {
    title: "Professional Presence",
    description:
      "Business address and live answering combined for a complete professional solution.",
    price: "$99",
    featured: true,
    badge: "Most Popular",
  },
  {
    title: "Executive Workspace",
    description:
      "Virtual office plus workspace access and meeting room hours.",
    price: "$399",
    featured: false,
  },
  {
    title: "Elite Workspace",
    description:
      "Our most comprehensive virtual office with expanded workspace access.",
    price: "$499",
    featured: false,
  },
];

const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);


const planData = [
  {
    feature: "Monthly Price",
    business: "From $59",
    liveAnswering: "From $69",
    professionalPresence: "From $119",
    executiveWorkspace: "$399",
    eliteWorkspace: "$499",
    type: "price",
  },
  {
    feature: "Prestigious Houston business address",
    business: "✓",
    liveAnswering: "—",
    professionalPresence: "✓",
    executiveWorkspace: "✓",
    eliteWorkspace: "✓",
  },
  {
    feature: "Secure mail handling & pickup",
    business: "✓",
    liveAnswering: "—",
    professionalPresence: "✓",
    executiveWorkspace: "✓",
    eliteWorkspace: "✓",
  },
  {
    feature: "Dedicated local phone number",
    business: "—",
    liveAnswering: "✓",
    professionalPresence: "✓",
    executiveWorkspace: "✓",
    eliteWorkspace: "✓",
  },
  {
    feature: "Live receptionist answering",
    business: "—",
    liveAnswering: "✓",
    professionalPresence: "✓",
    executiveWorkspace: "✓",
    eliteWorkspace: "✓",
  },
  {
    feature: "Custom call greeting",
    business: "—",
    liveAnswering: "✓",
    professionalPresence: "✓",
    executiveWorkspace: "✓",
    eliteWorkspace: "✓",
  },
  {
    feature: "Voicemail to email",
    business: "—",
    liveAnswering: "✓",
    professionalPresence: "✓",
    executiveWorkspace: "✓",
    eliteWorkspace: "✓",
  },
  {
    feature: "Meeting room access",
    business: "Member rates",
    liveAnswering: "Member rates",
    professionalPresence: "Member rates",
    executiveWorkspace: "2 hrs/month included",
    eliteWorkspace: "4 hrs/month included",
  },
  {
    feature: "Coworking lounge access",
    business: "—",
    liveAnswering: "—",
    professionalPresence: "—",
    executiveWorkspace: "4 hrs/day",
    eliteWorkspace: "4 hrs/day",
  },
  {
    feature: "Private day office use",
    business: "—",
    liveAnswering: "—",
    professionalPresence: "—",
    executiveWorkspace: "2 days/month",
    eliteWorkspace: "4 days/month",
  },
  {
    feature: "Online booking portal",
    business: "✓",
    liveAnswering: "✓",
    professionalPresence: "✓",
    executiveWorkspace: "✓",
    eliteWorkspace: "✓",
  },
];

const columns = [
  { key: "feature", label: "Features" },
  { key: "business", label: "Business" },
  { key: "liveAnswering", label: "Live Answering" },
  { key: "professionalPresence", label: "Professional Presence", highlight: true },
  { key: "executiveWorkspace", label: "Executive Workspace" },
  { key: "eliteWorkspace", label: "Elite Workspace" },
];

const renderCell = (value, highlighted = false, isPrice = false) => {
  const isCheck = value === "✓";
  const isDash = value === "—";

  return (
    <span
      className={[
        "comparison-cell-content",
        isCheck ? "is-check" : "",
        isDash ? "is-dash" : "",
        highlighted ? "is-highlighted" : "",
        isPrice ? "is-price" : "",
      ].join(" ")}
    >
      {value}
    </span>
  );
};

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);



const services = [
  {
    image: ov1,
    title: "Business Address",
    description:
      "Use our address for company registration and business correspondence.",
  },
  {
    image: ovmp,
    title: "Mail Handling",
    description:
      "Secure mail collection with optional forwarding.",
  },
  {
    image: ovp,
    title: "Call Answering",
    description:
      "Professional receptionists answer calls in your company name.",
  },
  {
    image: ovmm,
    title: "Meeting Rooms",
    description:
      "Host meetings in premium conference rooms.",
  },
];
  return (
    <div>

          <Helmet>
      
      <title>Virtual Office Houston | Business Address & Mail Services</title>
      <meta name="description" content="Looking for a virtual office in Houston? Xceed Office offers premium business addresses, mail handling, live receptionist services, and flexible virtual office plans."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>
      {/* 🔶 HERO SECTION */}
      <section className="p_main">
        <div className="p_main_sec">
          <h1>
            <span style={{ color: "#EEBD2B" }}>            Virtual Office Real
</span>
            <br /> 
Business Presence
          </h1>

          <p>            Establish your company with a prestigious business address an
professional support designed for modern businesses
 </p>

                  <PopupButton
           url="https://calendly.com/xceedoffice-info/new-meeting"
           rootElement={document.getElementById("root")}
           text="Schedule a Private Tour"
           className="cta__btn cta__btn--primary"
         />{" "}
          <button style={{ background: "#0D0D0D", color: "#EEBD2B", opacity: 1 }}>
            Speak With Our Team
          </button>
        </div>
      </section>


  <section className="xceed-section">
  <div className="xceed-container">
    <h2 className="xceed-title">The Xceed Advantage</h2>

    <div className="xceed-cards">
      {advantages.map((item, index) => (
        <div className="xceed-card" key={index}>
          <div className="xceed-icon-box">
            <img
              src={item.image}
              alt={item.title}
              className="xceed-icon-image"
            />
          </div>

          <h3 className="xceed-card-title">{item.title}</h3>
          <p className="xceed-card-text">{item.description}</p>
        </div>
      ))}
    </div>
  </div>
</section>
 <section className="plans-section">
      <div className="plans-container">
        <h2 className="plans-title">Virtual Office Plans</h2>

        <div className="plans-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`plan-card ${plan.featured ? "featured" : ""}`}
            >
              {plan.featured && (
                <div className="plan-badge">{plan.badge}</div>
              )}

              <h3 className="plan-name">
                {plan.title}
                {plan.featured && <span className="star">★</span>}
              </h3>

              <p className="plan-description">{plan.description}</p>

              <div className="plan-price">
                <span className="from">From </span>
                <span className="amount">{plan.price}</span>
                <span className="duration"> / month</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="why-section">
      <div className="why-container">
        <h2 className="why-title">
          Why Businesses Choose Xceed Office
        </h2>

        <p className="why-text">
          Modern businesses need credibility without the cost of long office leases.
        </p>

        <p className="why-text">
          Xceed Office allows companies to establish a professional presence with a prestigious business address, live receptionist services, and access to premium workspace when needed.
        </p>

        <p className="why-text">
          This combination gives businesses the flexibility to operate from anywhere while maintaining a polished and credible image.
        </p>
      </div>
    </section>
 <section className="comparison-section">
      <div className="comparison-container">
        <h2 className="comparison-title">
          Choose the plan that fits your business
        </h2>

        <div className="comparison-table-wrap">
          <table className="comparison-table">
            <thead>
              <tr>
                {columns.map((col) => (
                  <th
                    key={col.key}
                    className={col.highlight ? "highlight-column" : ""}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {planData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col) => {
                    const value = row[col.key];
                    const isFeatureCol = col.key === "feature";
                    const isHighlighted = !!col.highlight;
                    const isPriceRow = row.type === "price";

                    return (
                      <td
                        key={col.key}
                        className={[
                          isFeatureCol ? "feature-column" : "",
                          isHighlighted ? "highlight-column" : "",
                        ].join(" ")}
                      >
                        {isFeatureCol ? (
                          <span className="feature-text">{value}</span>
                        ) : (
                          renderCell(value, isHighlighted, isPriceRow)
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  

       <section className="cta-section">
      <div className="cta-container">
        <h2 className="cta-title">
          Looking for a Full-Time Office?
        </h2>

        <p className="cta-text">
          Some businesses prefer a private executive office instead of a virtual office membership.
        </p>

        <p className="cta-text">
          Explore our fully serviced private offices with flexible terms and premium amenities.
        </p>
        <a href="https://xceed.nexudus.site/Xceed/checkout/tariffs?type=1&start=2026-07-07T19%3A00%3A00.000-05%3A00&end=2026-07-07T20%3A00%3A00.000-05%3A00">
        <button className="cta-button">
          View Office Options <span className="arrow">→</span>
        </button>
        </a>
      </div>
    </section>

       <section className="services-section">
  <div className="services-container">
    <h2 className="services-title">
      Professional Business Services
    </h2>

    <div className="services-grid">
      {services.map((service, index) => (
        <div className="service-card" key={index}>
          <div className="service-icon-box">
            <img
              src={service.image}
              alt={service.title}
              className="service-icon-image"
            />
          </div>

          <h3 className="service-title">{service.title}</h3>

          <p className="service-description">
            {service.description}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
      {/* ✅ CTA SECTION (ADDED) */}
      <section  className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
          <PopupButton
  url="https://calendly.com/xceedoffice-info/new-meeting"
  rootElement={document.getElementById("root")}
  text="Schedule a Tour →"
  className="cta__btn cta__btn--primary"
>
</PopupButton>
            <a href="tel:346-502-2552">
            <button className="cta__btn cta__btn--ghost" type="button">
              <span className="cta__btnIcon"><IconCall /></span>
              Call Now
            </button>
            </a>
          </div>

        </div>
      </section>


    </div>
  )
}

export default Virtual